import { Tab, Nav, OverlayTrigger, Tooltip } from "react-bootstrap";
import { connect, useDispatch, useSelector } from "react-redux";
import { params, const_var } from "../../../redux/reducers/reducer";
import { hasGableLeanto } from "../../../redux/reducers/utils.js";
import RenderLean from "./RenderLean.js";
import Loader from "../../Loader/Loader.jsx";
import { fullyWrapClick, setBuildingFlags, setNavtab, showAlert } from "../../../action/index.js";
import { addLeantoPorches,addLeantoSection } from "../../../action/lean_building_pricing/api.actions.getPricingDataForLeanto.js";

const SavingEffect = ({ active }) => (
	<span className={active ? "active saving-effect saving-effect-type-2" : "saving-effect saving-effect-type-2"}>
		<span></span>
		<span></span>
		<span></span>
	</span>
);

const NoLean = ({ leanType, is_loader }) => (
	<div className="alert-data mb-20">
		{is_loader && const_var.navEventKey.leanto === leanType ? (
			<div className="alert-content mw-200" style={{ margin: "50px 0" }}>
				<SavingEffect active />
			</div>
		) : (
			<div className="alert-content mw-200">
				<p>Add the lean-tos to your building from here</p>
			</div>
		)}
	</div>
);

const LeanNavItem = ({ eventKey, label, isActive, isLoading, onNavSelect, onRadioClick }) => (
	<Nav.Item className="nav-item-strip">
		<Nav.Link eventKey={eventKey} className="nav-link-strip" onSelect={onNavSelect}>
			<span className="nav-link-text">{label}</span>
			<SavingEffect active={isLoading} />
		</Nav.Link>
		<div className={isActive ? "check-button-group active" : "check-button-group"}>
			<input type="radio" name={label} checked={isActive} onClick={onRadioClick} className="check-button-form" id={eventKey} />
			<label htmlFor={eventKey} className="check-button-label"></label>
		</div>
	</Nav.Item>
);

const WrapBadge = ({ id, label, isChecked, onClick }) => (
	<div className="badge-item-group">
		<span className={isChecked ? "badge badge-radio badge-outline-default active" : "badge badge-radio badge-outline-default"}>
			<div className={isChecked ? "check-button-group active" : "check-button-group"}>
				<input type="checkbox" value={label} name="wrap" checked={isChecked} onClick={onClick} className="check-button-form" id={id} />
				<label htmlFor={id} className="check-button-label">
					{label}
				</label>
			</div>
		</span>
	</div>
);

const Leantos = () => {
	const {const_var,params,isLTBuilding,micro_loader} =  useSelector(state=>state.reducer); 
	const dispatch = useDispatch();
	let frontLeanData, backLeanData, leftLeanData, rightLeanData;
	if (const_var.post_data.building !== undefined && const_var.post_data.building.leanto.length > 0) {
		for (let i = 0; i <= const_var.post_data.building.leanto.length - 1; i++) {
			const lean = const_var.post_data.building.leanto[i];
			if (lean.leanto_type === 2) rightLeanData = lean;
			else if (lean.leanto_type === 1) leftLeanData = lean;
			else if (lean.leanto_type === 3) frontLeanData = lean;
			else if (lean.leanto_type === 4) backLeanData = lean;
		}
	}
	let isWrap_FL = true;
	let isWrap_FR = true;
	let isWrap_BL = true;
	let isWrap_BR = true;
	let isWrap_Full = true;

	if (params.leanStyle.front === "gable") {
		isWrap_FL = false;
		isWrap_FR = false;
		isWrap_Full = false;
	}
	if (params.leanStyle.back === "gable") {
		isWrap_BL = false;
		isWrap_BR = false;
		isWrap_Full = false;
	}
	if (params.leanStyle.left === "gable") {
		isWrap_FL = false;
		isWrap_BL = false;
		isWrap_Full = false;
	}
	if (params.leanStyle.right === "gable") {
		isWrap_FR = false;
		isWrap_BR = false;
		isWrap_Full = false;
	}

	if (const_var.leanDimension == undefined) return null;
	const freeStandingBuilding = const_var?.defaultBuildingArr?.[const_var.BuldingIDforReset]?.image_name?.split(".")?.[0] ?? "";
	if (freeStandingBuilding !== undefined && freeStandingBuilding.includes("Free_Standing")) {
		const_var.navEventKey.leanto = "rightLean";
	}
	const checkTypeEdit =
		const_var.crmSetting.is_Edit == true
			? true
			: params.add_left_front_lean_porch == false && params.add_right_front_lean_porch == false && params.add_left_back_lean_porch == false && params.add_right_back_lean_porch == false;

	if (const_var.leanHasDoublelegshow === true) {
		const ll = const_var.commonBuildingFlag.leftLean;
		if (ll.leftLeanHeight == false && ll.leftLeanHeightChk != undefined && ll.leftLeanHeightChk) {
			ll.leftLeanHeightChk = false;
		}
	}
	if (const_var.leanRHasDoublelegshow === true) {
		const rl = const_var.commonBuildingFlag.rightLean;
		if (rl.rightLeanHeight == false && rl.rightLeanHeightChk != undefined && rl.rightLeanHeightChk) {
			rl.rightLeanHeightChk = false;
		}
	}
	if (const_var.leanFHasDoublelegshow === true) {
		const fl = const_var.commonBuildingFlag.frontLean;
		if (fl.frontLeanHeight == false && fl.frontLeanHeightChk != undefined && fl.frontLeanHeightChk) {
			fl.frontLeanHeightChk = false;
		}
	}
	if (const_var.leanBHasDoublelegshow === true) {
		const bl = const_var.commonBuildingFlag.backLean;
		if (bl.backLeanHeight == false && bl.backLeanHeightChk != undefined && bl.backLeanHeightChk) {
			bl.backLeanHeightChk = false;
		}
	}

	const shouldShowLeanTab = (leanType) => {
		if (isLTBuilding) {
			return !hasGableLeanto(leanType);
		}
		return true;
	};

	const_var.leanto_condition_by_mfg.side_lean_to = true;
	const_var.leanto_condition_by_mfg.end_lean_to = true;

	const shouldShowAddWrapButton = ["left", "right", "back", "front"].filter((l) => params.leanStyle[l] === "standard").length > 1;

	const addLeftFrontLeanToPorch = () => {
		dispatch(addLeantoPorches(params.add_left_front_lean_porch, "addLeftFrontLeanToPorch", 2, params.add_front_lean, params.add_left_lean, params.add_right_lean, params.add_back_lean, "FullBuilding"));
	};
	const addRightFrontLeanToPorch = () => {
		dispatch(addLeantoPorches(params.add_right_front_lean_porch, "addRightFrontLeanToPorch", 2, params.add_front_lean, params.add_left_lean, params.add_right_lean, params.add_back_lean, "FullBuilding"));
	};
	const addLeftBackLeanToPorch = () => {
		 dispatch(addLeantoPorches(params.add_left_back_lean_porch, "addLeftBackLeanToPorch", 2, params.add_front_lean, params.add_left_lean, params.add_right_lean, params.add_back_lean, "FullBuilding"));
	};
	const addRightBackLeanToPorch = () => {
		 dispatch(addLeantoPorches(params.add_right_back_lean_porch, "addRightBackLeanToPorch", 2, params.add_front_lean, params.add_left_lean, params.add_right_lean, params.add_back_lean, "FullBuilding"));
	};

	const handleWrapClick = (e) => {
		const leanArr = [
			{ lean: "left", side: "" },
			{ lean: "right", side: "R" },
			{ lean: "front", side: "F" },
			{ lean: "back", side: "B" }
		];
		let isWrap = false;
		let isFirstLean = true;
		let count = 0;

		for (let i = 0; i < leanArr.length; i++) {
			if (params[`add_${leanArr[i].lean}_lean`] == true) {
				if (
					(params[`lean${leanArr[count].side}_p_w`] == params[`lean${leanArr[i].side}_p_w`] &&
						params[`lean${leanArr[count].side}_p_h`] == params[`lean${leanArr[i].side}_p_h`] &&
						params[`b_l_t_r_p${leanArr[count].side}`] == params[`b_l_t_r_p${leanArr[i].side}`]) ||
					isFirstLean
				) {
					isWrap = true;
				} else {
					isWrap = false;
					break;
				}
				count = i;
				isFirstLean = false;
			}
		}

		const noLeansAdded = !params.add_left_lean && !params.add_right_lean && !params.add_front_lean && !params.add_back_lean;

		if (noLeansAdded || isWrap) {
			/*SE3-I4119 under edit mode, on decreasing the central building height and adding full building wrap and insulation,
			lean to's pricing is coming incorrect Start*/
			const functionsDelay = [addLeftFrontLeanToPorch, addRightFrontLeanToPorch, addLeftBackLeanToPorch, addRightBackLeanToPorch];

			if (e.target.checked == true) {
				 dispatch(fullyWrapClick(true));
				functionsDelay.forEach((func, index) => {
					if (index === 0) {
						func();
					} else {
						setTimeout(() => func(), index * 500);
					}
				});
			} else {
				dispatch(fullyWrapClick(false));
				functionsDelay.forEach((func) => func());
			}
			/*SE3-I4119 under edit mode, on decreasing the central building height and adding full building wrap and insulation,
			lean to's pricing is coming incorrect END*/
		} else {
			dispatch(showAlert("YouCanNotAddPorch"));
		}
	};
	const { is_loader } = const_var;
	const activeTab = const_var.navEventKey.leanto;
	const { side_lean_to, end_lean_to } = const_var.leanto_condition_by_mfg;
	const isFullBuildingWrap = params.add_left_front_lean_porch && params.add_right_front_lean_porch && params.add_left_back_lean_porch && params.add_right_back_lean_porch;
	return (
		<div>
			<div className="building-elements-sec">
				<div className="building-elements-sec-mid pt-0">
					<div className="building-elements-sec-mid-scroll">
						<form>
							<div className="section-seprator">
								{micro_loader ? (
									<Loader />
								) : (
									<Tab.Container activeKey={activeTab}>
										<Nav variant="tabs" className="nav-tab-strip">
											{/* Left */}
											{side_lean_to && params.singleSlope != true && shouldShowLeanTab("left") && (
												<LeanNavItem
													eventKey="leftLean"
													label="Left"
													isActive={params.add_left_lean == true}
													isLoading={is_loader && activeTab === "leftLean" && params.add_left_lean == true}
													onNavSelect={(e) => dispatch(setNavtab("nav", e))}
													onRadioClick={(e) => {
														dispatch(addLeantoSection(e.target.value, "addLeftLean", params.add_left_front_lean_porch, false, params.add_left_back_lean_porch, false));
														dispatch(setNavtab("input", e));
													}}
												/>
											)}

											{/* Right */}
											{side_lean_to && shouldShowLeanTab("right") && (
												<LeanNavItem
													eventKey="rightLean"
													label="Right"
													isActive={params.add_right_lean == true}
													isLoading={is_loader && activeTab === "rightLean" && params.add_right_lean == true}
													onNavSelect={(e) => dispatch(setNavtab("nav", e))}
													onRadioClick={(e) => {
														dispatch(addLeantoSection(e.target.value, "addRightLean", false, params.add_right_front_lean_porch, false, params.add_right_back_lean_porch));
														dispatch(setNavtab("input", e));
													}}
												/>
											)}

											{/* Front */}
											{end_lean_to && params.singleSlope != true && shouldShowLeanTab("front") && (
												<LeanNavItem
													eventKey="frontLean"
													label="Front"
													isActive={params.add_front_lean == true}
													isLoading={is_loader && activeTab === "frontLean" && params.add_front_lean == true}
													onNavSelect={(e) => dispatch(setNavtab("nav", e))}
													onRadioClick={(e) => {
													 	dispatch(addLeantoSection(e.target.value, "addFrontLean", params.add_left_front_lean_porch, params.add_right_front_lean_porch, false, false));
														dispatch(setNavtab("input", e));
													}}
												/>
											)}

											{/* Back */}
											{end_lean_to && params.singleSlope != true && shouldShowLeanTab("back") && (
												<LeanNavItem
													eventKey="backLean"
													label="Back"
													isActive={params.add_back_lean == true}
													isLoading={is_loader && activeTab === "backLean" && params.add_back_lean == true}
													onNavSelect={(e) => dispatch(setNavtab("nav", e))}
													onRadioClick={(e) => {
													 	dispatch(addLeantoSection(e.target.value, "addBackLean", false, false, params.add_left_back_lean_porch, params.add_right_back_lean_porch));
														dispatch(setNavtab("input", e));
													}}
												/>
											)}
										</Nav>

										<Tab.Content className="tab-content-strip">
											{side_lean_to && shouldShowLeanTab("left") && (
												<Tab.Pane className="tab-pane-strip" eventKey="leftLean">
													{leftLeanData ? <RenderLean lean={leftLeanData} leanType="left" /> : <NoLean leanType="leftLean" is_loader={is_loader} />}
												</Tab.Pane>
											)}

											{side_lean_to && shouldShowLeanTab("right") && (
												<Tab.Pane className="tab-pane-strip" eventKey="rightLean">
													{rightLeanData ? <RenderLean lean={rightLeanData} leanType="right" /> : <NoLean leanType="rightLean" is_loader={is_loader} />}
												</Tab.Pane>
											)}

											{side_lean_to && shouldShowLeanTab("front") && (
												<Tab.Pane className="tab-pane-strip" eventKey="frontLean">
													{frontLeanData ? <RenderLean lean={frontLeanData} leanType="front" /> : <NoLean leanType="frontLean" is_loader={is_loader} />}
												</Tab.Pane>
											)}

											{side_lean_to && shouldShowLeanTab("back") && (
												<Tab.Pane className="tab-pane-strip" eventKey="backLean">
													{backLeanData ? <RenderLean lean={backLeanData} leanType="back" /> : <NoLean leanType="backLean" is_loader={is_loader} />}
												</Tab.Pane>
											)}
										</Tab.Content>
									</Tab.Container>
								)}
								<div className="card-footer-inner">
									<div className="add-action">
										<a className="btn btn-link btn-sm p-0" onClick={() => dispatch(setBuildingFlags("addWrap"))}>
											+ Add Wrap
										</a>
									</div>
								</div>
								{/* Wrap section */}
								{const_var.commonBuildingFlag.wrap == true && (isWrap_FL || isWrap_FR || isWrap_BL || isWrap_BR) && (
									<div className="wrap-action">
										<div className="control-label d-flex" style={{ lineHeight: "10px", marginBottom: "10px" }}>
											Wrap
											{((const_var.loginSession == true && params.m_s_n == 13 && const_var.leanto_condition_by_mfg.wrap_around == true) ||
												(const_var.loginSession == false && params.m_s_n == 13)) && (
													<OverlayTrigger placement="top" className="controller-tooltip" overlay={<Tooltip id="tooltip-wrapmap">Required Site Specific Engineering</Tooltip>}>
														<i className="icon icon-info-ico"></i>
													</OverlayTrigger>
												)}
										</div>

										<div className={is_loader ? "badge-list-group disabled" : "badge-list-group"}>
											{isWrap_FL && (
												<WrapBadge
													id="frontleft"
													label="Front Left"
													isChecked={params.add_left_front_lean_porch == true}
													onClick={() =>
														  dispatch(addLeantoPorches(
															params.add_left_front_lean_porch,
															"addLeftFrontLeanToPorch",
															2,
															params.add_front_lean,
															params.add_left_lean,
															params.add_right_lean,
															params.add_back_lean
														))
													}
												/>
											)}
											{isWrap_FR && (
												<WrapBadge
													id="frontRight"
													label="Front Right"
													isChecked={params.add_right_front_lean_porch == true}
													onClick={() =>
														 dispatch(addLeantoPorches(
															params.add_right_front_lean_porch,
															"addRightFrontLeanToPorch",
															2,
															params.add_front_lean,
															params.add_left_lean,
															params.add_right_lean,
															params.add_back_lean
														))
													}
												/>
											)}
											{isWrap_BL && (
												<WrapBadge
													id="backLeft"
													label="Back Left"
													isChecked={params.add_left_back_lean_porch == true}
													onClick={() =>
														  dispatch(addLeantoPorches(
															params.add_left_back_lean_porch,
															"addLeftBackLeanToPorch",
															2,
															params.add_front_lean,
															params.add_left_lean,
															params.add_right_lean,
															params.add_back_lean
														))
													}
												/>
											)}
											{isWrap_BR && (
												<WrapBadge
													id="backRight"
													label="Back Right"
													isChecked={params.add_right_back_lean_porch == true}
													onClick={() =>
														 dispatch(addLeantoPorches(
															params.add_right_back_lean_porch,
															"addRightBackLeanToPorch",
															2,
															params.add_front_lean,
															params.add_left_lean,
															params.add_right_lean,
															params.add_back_lean
														))
													}
												/>
											)}
											{isWrap_Full && <WrapBadge id="fullBuilding" label="Full Building" isChecked={!!isFullBuildingWrap} onClick={handleWrapClick} />}
										</div>
									</div>
								)}
							</div>
						</form>

						{shouldShowAddWrapButton && (const_var.crmSetting.api_token === "9UUu7wU97NCqT3V4j57UEFaQoh045B1VpEzKDCbdxQENJZ0HW2XZWJ4KdPxvS0Sf" || params.m_s_n == 72) && (
							<div className={params.singleSlope != true && const_var.leanto_condition_by_mfg.wrap_around == true ? "storage-info-sec" : "storage-info-sec d-none"}>
								Wrap around lean-tos may require site specific plans, please contact your local office for more details.
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};
export default Leantos;
